package com.jet.classroomhero.entities.errors

import kotlinx.serialization.Serializable

// generic request / response error object from django
@Serializable
data class CHErrorMessage(val message: String)

@Serializable
data class CHErrorDetail(val detail: String)